/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDiagram } from "../../d-diagram";
import { DThemeDarkDiagramBase } from "./d-theme-dark-diagram-base";

export class DThemeDarkDiagram extends DThemeDarkDiagramBase implements DThemeDiagram {}
